import { AwsIntegrationView } from "../../useSearchCloudIntegrations/gql";

// TODO: replace with AAC
export const canDeleteCloudIntegration = (integration: AwsIntegrationView) => {
  return !integration.hasAttachedStacks && !integration.hasAttachedScans;
};

export const getCannotDeleteIntegrationTooltip = (integration: AwsIntegrationView) => {
  if (integration.hasAttachedStacks && integration.hasAttachedScans) {
    return "Cannot delete this integration because it is attached to a stack and a scan";
  }
  if (integration.hasAttachedStacks) {
    return "Cannot delete this integration because it is attached to a stack";
  }
  return "Cannot delete this integration because it is attached to a scan";
};
